import actions from 'modules/tool/list/toolListActions';
import paginationReducer from 'modules/shared/pagination/paginationReducer';

export default paginationReducer(actions);
